/**
 * 将消息转换为html正文
 * Bai.Zhiming
 * 2019-7-22
 */
angular.module("convertMsgtoHtmlModule", [])
    .factory("convertMsgtoHtml", [function() {
        return {

            /**
             * [MsgToHtml description] 消息转换为html正文
             * @param {[type]} msg [description]
             */
            MsgToHtml(msg) {
                var html = "",
                    elems, elem, type, content;
                elems = msg.getElems(); //获取消息包含的元素数组
                for (var i in elems) {
                    elem = elems[i];
                    type = elem.getType(); //获取元素类型
                    content = elem.getContent(); //获取元素对象
                    switch (type) {
                        case webim.MSG_ELEMENT_TYPE.TEXT:
                            html += this.convertTextMsgToHtml(content);
                            break;
                        case webim.MSG_ELEMENT_TYPE.FACE:
                            html += this.convertFaceMsgToHtml(content);
                            break;
                        case webim.MSG_ELEMENT_TYPE.IMAGE:
                            html += this.convertImageMsgToHtml(content);
                            break;
                        case webim.MSG_ELEMENT_TYPE.SOUND:
                            html += this.convertSoundMsgToAMRPlayer(content);
                            break;
                        case webim.MSG_ELEMENT_TYPE.FILE:
                            html += this.convertFileMsgToHtml(content);
                            break;
                        case webim.MSG_ELEMENT_TYPE.LOCATION: //暂不支持地理位置
                            //html += convertLocationMsgToHtml(content);
                            break;
                        case webim.MSG_ELEMENT_TYPE.CUSTOM:
                            html += this.convertCustomMsgToHtml(content);
                            break;
                        case webim.MSG_ELEMENT_TYPE.GROUP_TIP:
                            html += this.convertGroupTipMsgToHtml(content);
                            break;
                        default:
                            webim.Log.error('未知消息元素类型: elemType=' + type);
                            break;
                    }
                }
                return html;
            },
            /**
             * [convertTextMsgToHtml description] 解析文本消息
             * @param  {[type]} content [description]
             * @return {[type]}         [description]
             */
            convertTextMsgToHtml(content) {
                return content.getText();
            },
            /**
             * [convertFaceMsgToHtml description] 解析表情消息
             * @param  {[type]} content [description]
             * @return {[type]}         [description]
             */
            convertFaceMsgToHtml(content) {
                var index = content.getIndex();
                var data = content.getData();
                var url = null;
                var emotion = webim.Emotions[index];
                if (emotion && emotion[1]) {
                    url = emotion[1];
                }
                if (url) {
                    return "<img src='" + url + "'/>";
                } else {
                    return data;
                }
            },
            /**
             * [convertImageMsgToHtml description] 解析图片消息
             * @param  {[type]} content [description]
             * @return {[type]}         [description]
             */
            convertImageMsgToHtml(content) {
                var smallImage = content.getImage(webim.IMAGE_TYPE.SMALL); //小图
                var bigImage = content.getImage(webim.IMAGE_TYPE.LARGE); //大图
                var oriImage = content.getImage(webim.IMAGE_TYPE.ORIGIN); //原图
                if (!bigImage) {
                    bigImage = smallImage;
                }
                if (!oriImage) {
                    oriImage = smallImage;
                }
                return "<img src='" + smallImage.getUrl() + "#" + bigImage.getUrl() + "#" + oriImage.getUrl() + "' style='CURSOR: hand' id='" + content.getImageId() + "' bigImgUrl='" + bigImage.getUrl() + "' onclick='imageClick(this)' />";
            },
            /**
             * [convertSoundMsgToAMRPlayer description] 解析语音消息
             * @param  {[type]} content [description]
             * @return {[type]}         [description]
             */
            convertSoundMsgToAMRPlayer(content) {
                var iconStartChar = '&nbsp;&nbsp;&#9658;&nbsp;&nbsp;';
                var btnid = ['amrplay_btn_', content.uuid, '-', Math.round(Math.random() * 1000000)].join('');
                var aElmentString = ['<button id="', btnid, '" style="font-size:1.5em;" data-url="', content.downUrl, '">', iconStartChar, '</button>'].join('');
                setTimeout(function() {
                    var btelm = document.getElementById(btnid);
                    btelm.onclick = function(event) {
                        var amr = new BenzAMRRecorder();
                        var seed = null;
                        amr.onPlay(function() {
                            let arr = ['&#9744;', '&#9744;', '&#9744;', '&#9744;', '&#9744;'];
                            var count = 0;
                            seed = setInterval(function() {
                                arr = ['&#9744;', '&#9744;', '&#9744;', '&#9744;', '&#9744;'];
                                arr[count % arr.length] = '&#9635;';
                                event.target.innerHTML = arr.join('');
                                count++;
                            }, 90)
                        });
                        amr.onStop(function() {
                            clearInterval(seed);
                            event.target.innerHTML = iconStartChar;
                        });
                        amr.initWithUrl(content.downUrl).then(function() {
                            amr.play();
                        });
                    }
                }, 0);
                return aElmentString;
            },
            /**
             * [convertFileMsgToHtml description] 解析文件消息元素
             * @param  {[type]} content [description]
             * @return {[type]}         [description]
             */
            convertFileMsgToHtml(content) {
                var fileSize = Math.round(content.getSize() / 1024);
                return '<a href="' + content.getDownUrl() + '" title="单击下载文件" ><i class="glyphicon glyphicon-file">&nbsp;' + content.getName() + '(' + fileSize + 'KB)</i></a>';
            },
            /**
             * [convertLocationMsgToHtml description] 解析位置消息元素
             * @param  {[type]} content [description]
             * @return {[type]}         [description]
             */
            convertLocationMsgToHtml(content) {
                return '经度=' + content.getLongitude() + ',纬度=' + content.getLatitude() + ',描述=' + content.getDesc();
            },
            /**
             * [convertCustomMsgToHtml description] 解析自定义消息元素
             * @param  {[type]} content [description]
             * @return {[type]}         [description]
             */
            convertCustomMsgToHtml(content) {
                var data = content.getData();
                var desc = content.getDesc();
                var ext = content.getExt();
                return data//"data=" + data + ", desc=" + desc + ", ext=" + ext;
            },
            /**
             * [convertGroupTipMsgToHtml description] 解析群提示消息元素
             * @param  {[type]} content [description]
             * @return {[type]}         [description]
             */
            convertGroupTipMsgToHtml(content) {
                var WEB_IM_GROUP_TIP_MAX_USER_COUNT = 10;
                var text = "";
                var maxIndex = WEB_IM_GROUP_TIP_MAX_USER_COUNT - 1;
                var opType, opUserId, userIdList;
                opType = content.getOpType(); //群提示消息类型（操作类型）
                opUserId = content.getOpUserId(); //操作人 ID
                switch (opType) {
                    case webim.GROUP_TIP_TYPE.JOIN: //加入群
                        userIdList = content.getUserIdList();
                        //text += opUserId + "邀请了";
                        for (var m in userIdList) {
                            text += userIdList[m] + ",";
                            if (userIdList.length > WEB_IM_GROUP_TIP_MAX_USER_COUNT && m == maxIndex) {
                                text += "等" + userIdList.length + "人";
                                break;
                            }
                        }
                        text += "加入该群";
                        break;
                    case webim.GROUP_TIP_TYPE.QUIT: //退出群
                        text += opUserId + "主动退出该群";
                        break;
                    case webim.GROUP_TIP_TYPE.KICK: //踢出群
                        text += opUserId + "将";
                        userIdList = content.getUserIdList();
                        for (var m in userIdList) {
                            text += userIdList[m] + ",";
                            if (userIdList.length > WEB_IM_GROUP_TIP_MAX_USER_COUNT && m == maxIndex) {
                                text += "等" + userIdList.length + "人";
                                break;
                            }
                        }
                        text += "踢出该群";
                        break;
                    case webim.GROUP_TIP_TYPE.SET_ADMIN: //设置管理员
                        text += opUserId + "将";
                        userIdList = content.getUserIdList();
                        for (var m in userIdList) {
                            text += userIdList[m] + ",";
                            if (userIdList.length > WEB_IM_GROUP_TIP_MAX_USER_COUNT && m == maxIndex) {
                                text += "等" + userIdList.length + "人";
                                break;
                            }
                        }
                        text += "设为管理员";
                        break;
                    case webim.GROUP_TIP_TYPE.CANCEL_ADMIN: //取消管理员
                        text += opUserId + "取消";
                        userIdList = content.getUserIdList();
                        for (var m in userIdList) {
                            text += userIdList[m] + ",";
                            if (userIdList.length > WEB_IM_GROUP_TIP_MAX_USER_COUNT && m == maxIndex) {
                                text += "等" + userIdList.length + "人";
                                break;
                            }
                        }
                        text += "的管理员资格";
                        break;
                    case webim.GROUP_TIP_TYPE.MODIFY_GROUP_INFO: //群资料变更
                        text += opUserId + "修改了群资料：";
                        var groupInfoList = content.getGroupInfoList();
                        var type, value;
                        for (var m in groupInfoList) {
                            type = groupInfoList[m].getType();
                            value = groupInfoList[m].getValue();
                            switch (type) {
                                case webim.GROUP_TIP_MODIFY_GROUP_INFO_TYPE.FACE_URL:
                                    text += "群头像为" + value + "; ";
                                    break;
                                case webim.GROUP_TIP_MODIFY_GROUP_INFO_TYPE.NAME:
                                    text += "群名称为" + value + "; ";
                                    break;
                                case webim.GROUP_TIP_MODIFY_GROUP_INFO_TYPE.OWNER:
                                    text += "群主为" + value + "; ";
                                    break;
                                case webim.GROUP_TIP_MODIFY_GROUP_INFO_TYPE.NOTIFICATION:
                                    text += "群公告为" + value + "; ";
                                    break;
                                case webim.GROUP_TIP_MODIFY_GROUP_INFO_TYPE.INTRODUCTION:
                                    text += "群简介为" + value + "; ";
                                    break;
                                default:
                                    text += "未知信息为:type=" + type + ",value=" + value + "; ";
                                    break;
                            }
                        }
                        break;
                    case webim.GROUP_TIP_TYPE.MODIFY_MEMBER_INFO: //群成员资料变更(禁言时间)
                        text += opUserId + "修改了群成员资料:";
                        var memberInfoList = content.getMemberInfoList();
                        var userId, shutupTime;
                        for (var m in memberInfoList) {
                            userId = memberInfoList[m].getUserId();
                            shutupTime = memberInfoList[m].getShutupTime();
                            text += userId + ": ";
                            if (shutupTime != null && shutupTime !== undefined) {
                                if (shutupTime == 0) {
                                    text += "取消禁言; ";
                                } else {
                                    text += "禁言" + shutupTime + "秒; ";
                                }
                            } else {
                                text += " shutupTime为空";
                            }
                            if (memberInfoList.length > WEB_IM_GROUP_TIP_MAX_USER_COUNT && m == maxIndex) {
                                text += "等" + memberInfoList.length + "人";
                                break;
                            }
                        }
                        break;
                    default:
                        text += "未知群提示消息类型：type=" + opType;
                        break;
                }
                return text;
            }
        }
    }]);